import axios from 'axios';

export default {
  state: {
    active: null,
    places: [],
    map: true,
    page: 1,
    list_places: false,
    type_places: 'all',
  },
  mutations: {
    setPlaces(state, places) {
      state.places = places;
    },
    setActivePlace(state, active) {
      state.active = active;
    },
    changeModePlaces(state, val) {
      state.map = val;
    },
    changeListPlaces(state, val) {
      state.list_places = val;
    },
    setTypePlaces(state, type) {
      state.type_places = type;
    },
  },
  actions: {
    setTypePlaces({ commit }, type) {
      commit('setTypePlaces', type);
    },
    async deletePlace({dispatch }, params) {
      let result;
      await axios
        .post(`/api/places/delete`, params)
        .then((response) => {
          result = response.data;
        })
        .catch((error) => {
          dispatch('addError', error.response.data)
        });
      return result;
    },
    async updatePlace({dispatch }, params) {
      let result;
      await axios
        .post(`/api/places/edit`, params)
        .then((response) => {
          result = response.data;
        })
        .catch((error) => {
          dispatch('addError', error.response.data)
        });
      return result;
    },
    async createPlace({ commit }, params) {
      let result;
      await axios
        .post(`/api/places/create`, params)
        .then((responce) => {
          commit('setActivePlace', responce.data);
          result = responce.data;
        })
      return result;
    },
    async fetchPlace({ commit }, params) {
      let result;
      await axios
        .post(`/api/places/place`, params)
        .then((responce) => {
          commit('setActivePlace', responce.data);
          result = responce.data;
        })
      return result;
    },
    async getPlaces({ commit }, params) {
      let result;
      await axios
        .post(`/api/places`, params)
        .then((responce) => {
          commit('setPlaces', responce.data);
          result = responce.data;
        })
      return result;
    },
    async addLovingPlace({ commit }, params) {
      let result;
      await axios
        .post(`/api/places/like`, params)
        .then((responce) => {
          commit;
          result = responce.data;
        })
      return result;
    },
    async removeLovingPlace({ commit }, params) {
      let result;
      await axios
        .post(`/api/places/unlike`, params)
        .then((responce) => {
          commit;
          result = responce.data;
        })
      return result;
    },
    async sendPlaceComment({ commit }, params) {
      let result;
      await axios
        .post(`/api/places/comment/create`, params)
        .then((response) => {
          commit
          result = response.data;
        })
      return result;
    },
    async sendPlaceCommentLike({ commit }, params) {
      let result;
      await axios
        .post(`/api/places/comment/like/add`, params)
        .then((response) => {
          commit
          result = response.data;
        })
      return result;
    },
    async deletePlaceCommentLike({ commit }, params) {
      let result;
      await axios
        .post(`/api/places/comment/like/delete`, params)
        .then((response) => {
          commit
          result = response.data;
        })
      return result;
    },
    changeListPlaces({ commit }, val) {
      commit('changeListPlaces', val);
    },
    setPlaces({ commit }, events) {
      commit('setPlaces', events);
    },
    setActivePlace({ commit }, active) {
      commit('setActivePlace', active);
    },
    changeModePlaces({ commit }, val) {
      commit('changeModePlaces', val);
    },
  },
  getters: {
    getActivePlaces: (s) => s.activePlaces,
    getActivePlace: (s) => s.active,
    getPlaces: (s) => s.places,
    getModePlaces: (s) => s.map,
    getListPlaces: (s) => s.list_places,
    getTypePlaces: (s) => s.type_places,
  },
};
